angular.module('app.factories').factory('PrintToConsole', ($rootScope, $state, $stateParams, $log, app) => {
    const handler = {
        active: app.debug,

        toggle() {
            handler.active = !handler.active;
        },

        init() {
            if (handler.active) {
                $rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState, fromParams) => {
                    $log.debug('$stateChangeStart --->> event, toState, toParams, fromState, fromParams');
                    $log.debug(event, toState, toParams, fromState, fromParams);
                });
                $rootScope.$on('$stateChangeError', (event, toState, toParams, fromState, fromParams, error) => {
                    $log.debug('$stateChangeError ---!! event, toState, toParams, fromState, fromParams, error');
                    $log.debug(event, toState, toParams, fromState, fromParams, error);
                });
                $rootScope.$on('$stateChangeSuccess', (event, toState, toParams, fromState, fromParams) => {
                    $log.debug('$stateChangeSuccess ---OK event, toState, toParams, fromState, fromParams');
                    $log.debug(event, toState, toParams, fromState, fromParams);
                });
                $rootScope.$on('$viewContentLoading', (event, viewConfig) => {
                    $log.debug('$viewContentLoading ---~~ event, viewConfig');
                    $log.debug(event, viewConfig);
                });
                $rootScope.$on('$viewContentLoaded', (event) => {
                    $log.debug('$viewContentLoaded ---ok event');
                    $log.debug(event);
                });
                $rootScope.$on('$stateNotFound', (event, unfoundState, fromState, fromParams) => {
                    $log.debug('$stateNotFound ---!! event, unfoundState, fromState, fromParams');
                    $log.debug(event, unfoundState, fromState, fromParams);
                });
            }
        },
    };

    return handler;
});
